import { ROUTES } from "constants/routes"
import { isPlatformCountryManager } from "utils/platformCountryAccess"

/** Base path for country list — platform console vs tenant portal. */
export const getCountriesBasePath = ({ accountType, accountScope } = {}) =>
  isPlatformCountryManager({ accountType, accountScope })
    ? ROUTES.SA_COUNTRIES
    : "/countries"

/** Dashboard fallback when country access is denied. */
export const getCountriesFallbackDashboard = ({ accountType, accountScope } = {}) =>
  isPlatformCountryManager({ accountType, accountScope })
    ? ROUTES.SA_DASHBOARD
    : ROUTES.DASHBOARD
